import React from "react";
import { Tag } from "antd";

const UseYnTag: React.FC<{ value: boolean }> = ({ value }) => (
  <Tag color={value ? "blue" : "default"}>{value ? "사용" : "미사용"}</Tag>
);

export default UseYnTag;
